import theme from '../../../muiTheme';

const styles = {

      media: {
        height: '100%'
      },
      overlay: {
        position: 'absolute',
        padding: '20px',
        top: '0px',
        left: '0px',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        boxSizing: 'border-box'
      },
      suggestedPost: {
        margin: '20px',
        cursor: 'pointer',
        
      },
      postCard: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        width: '300px',
        height: '400px',
        margin: '20px',
        [theme.breakpoints.down('sm')]: {
          width: '100vw',
          borderRadius: '0px',
          margin: '0px'
        },
      },
      cardAction: {
        display: 'block',
        textAlign: 'initial',
        height: '100%'
      },

}

export default styles; 